import { UploadSimpleIcon } from "@phosphor-icons/react/dist/csr/UploadSimple";
import { Button } from "@volca/ui/components/ui/button";
import { Stack } from "@volca/ui/components/ui/stack";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@volca/ui/components/ui/tooltip";
import { formatMoneyCents } from "@/core/utils/money";
import { useStAdjustmentsSection } from "./st-adjustments-section";

export const StAdjustmentsPreviewHeaderActions = () => {
  const { totals } = useStAdjustmentsSection();

  return (
    <Tooltip>
      <TooltipTrigger
        render={
          <Stack
            align="start"
            gap={4}
            direction="row"
            className="inline-flex"
            tabIndex={0}
          />
        }
      >
        <Button disabled>
          <UploadSimpleIcon data-icon="inline-start" />
          Push all {totals?.pending ?? 0} ·{" "}
          {formatMoneyCents(totals?.pending_amount_cents ?? 0) ?? "$0"}
        </Button>
      </TooltipTrigger>
      <TooltipContent>
        Contact the Volca team to enable PushPay for your account.
      </TooltipContent>
    </Tooltip>
  );
};
